import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import { KOEFF, KOEFF_X, KOEFF_Y, FRAME_WIDTH, OFFSET_X, OFFSET_Y } from './PleatedSreenConstants';


const DrawTopViewScreen = ({ doorData = null }) => {
    const svgRef = useRef();
    const canvasW = doorData?.frameData?.frameWidth * KOEFF_X;// + 65;
    const canvasH = 20;//doorData?.frameData?.frameHeight * 1 + 50;
  
    useEffect(() => {
        if (!svgRef.current) return;

        if ((isNaN(doorData.frameData.frameWidth))  || (parseFloat(doorData.frameData.frameWidth)  < 10)) {return;} //prevent one number numbering
        if ((isNaN(doorData.frameData.frameHeight)) || (parseFloat(doorData.frameData.frameHeight) < 10)) {return;} //prevent one number numbering

        const svg = initSvg();
        if (doorData?.frameData?.selectedDoor.id === 1) {
            drawScreen(svg,  OFFSET_X,  10, 5, doorData.frameData.frameWidth*KOEFF_X, 20, 'white', 2);
        }
        if (doorData?.frameData?.selectedDoor.id === 2) {
            drawScreen(svg,  OFFSET_X,  10, 5, doorData.frameData.frameWidth*KOEFF_X/2 - 40, 10, 'white', 2);
            drawScreen(svg,  30 + doorData.frameData.frameWidth*KOEFF_X/2,  
                10, 5, doorData.frameData.frameWidth*5/2 - 20, 18, 'white', 2);

        }
        //topView(svg, doorData);
    
    }, [doorData]); 
    function initSvg() {
        // Clear existing SVG
        d3.select(svgRef.current).selectAll('*').remove();
    
        // Create SVG element
        const svg = d3
          .select(svgRef.current)
          .attr('width', canvasW)
          .attr('height', canvasH);
          //.style('border', '1px solid black');
    
        return svg;
    }
    function drawLineWithOutline(svg, x1, y1, x2, y2, color = 'white', thickness = 2, outlineColor = 'black', outlineWidth = 1) {
        // First draw the outline (behind)
        svg.append('line')
          .attr('x1', x1)
          .attr('y1', y1)
          .attr('x2', x2)
          .attr('y2', y2)
          .attr('stroke', outlineColor)
          .attr('stroke-width', thickness + 2 * outlineWidth); // Outline wraps around
      
        // Then draw the main colored line (on top)
        svg.append('line')
          .attr('x1', x1)
          .attr('y1', y1)
          .attr('x2', x2)
          .attr('y2', y2)
          .attr('stroke', color)
          .attr('stroke-width', thickness);
    }
    function drawScreen(svg, x, y, height, totalLength, numSegments, color = 'white', thickness = 2) {
        const width = totalLength / numSegments;
        const points = [];
        let direction = -1;
      
        for (let i = 0; i <= numSegments; i++) {
          points.push([x + i * width, y + direction * height]);
          direction *= -1;
        }
      
        for (let i = 0; i < points.length - 1; i++) {
          drawLineWithOutline(svg, points[i][0], points[i][1], points[i + 1][0], points[i + 1][1], color, thickness);
        }
      }

    return (
        <div>
          {doorData?.frameData?.selectedDoor && <div style={{ marginLeft: '3ch' }}><b>Top View</b></div>}  
          
         <svg ref={svgRef}></svg>
         
        </div>
    );
};

export default DrawTopViewScreen;
